import { useRef } from 'react';
import { useNamespaceCopy } from '@/i18n/ns';
import audioStatusCopy from '@/i18n/ns/meeting-audio-status';
import type { CaptureSource } from '@/speech/contracts';
import { LevelMeter } from './meeting-record-parts';
import { recorderElapsedMs, useMeetingRecorder } from './meeting-recorder';

/** Input status is separate from Stop, with visible labels for each side. */
export function MeetingSourceLevels() {
  const copy = useNamespaceCopy(audioStatusCopy);
  const sources = useMeetingRecorder((state) => state.sources);
  const levels = useMeetingRecorder((state) => state.sourceLevels);
  const elapsed = useMeetingRecorder(recorderElapsedMs);
  const lastHeard = useRef<Partial<Record<CaptureSource, number>>>({});
  const previous = useRef(elapsed);
  if (elapsed < previous.current) lastHeard.current = {};
  previous.current = elapsed;
  for (const source of sources)
    if ((levels?.[source] ?? 0) > 0.02) lastHeard.current[source] = elapsed;
  const quiet = sources.some((source) => elapsed - (lastHeard.current[source] ?? 0) >= 10_000);
  return (
    <section className="ws-meeting-source-levels">
      {sources.map((source) => {
        const label = source === 'mic' ? copy.microphoneLevel : copy.meetingAudioLevel;
        return (
          <div key={source} data-source-level={source}>
            <span>{label}</span>
            <LevelMeter level={levels?.[source] ?? 0} label={label} />
          </div>
        );
      })}
      {quiet && <p className="ws-page-note">{copy.silenceHint}</p>}
    </section>
  );
}
